// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"mL-z","carousel":"nL-z"};